export default __webpack_public_path__ + "442033220c0066afe2741c2a91b05a5b.svg";